import { useRef } from 'react';
import { FieldErrors } from 'react-hook-form';

export const useScroll = () => {
  const elRef = useRef<null | HTMLDivElement>(null);
  const hasScrolledToErrorRef = useRef(false);

  const scrollToError = (errors: FieldErrors) => {
    const errorList = Object.keys(errors);
    if (errorList.length) {
      if (elRef && elRef.current) {
        const current = elRef?.current;
        const labels = current.getElementsByTagName('label');
        if (labels && labels.length) {
          for (let i = 0; i < labels.length; i++) {
            const label = labels[i];
            const labelFor =
              label && label?.attributes ? label?.attributes?.getNamedItem('for') : null;
            if (labelFor && labelFor.value) {
              if (errorList.includes(labelFor.value)) {
                label.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                  inline: 'nearest',
                });
                break;
              }
            }
          }
        }
      }
    }
    return null;
  };

  const resetScrollRef = () => {
    hasScrolledToErrorRef.current = false;
  };

  const processFormErrors = (errors: FieldErrors | undefined, force = false) => {
    if (errors && Object.keys(errors).length > 0) {
      if (hasScrolledToErrorRef.current && !force) {
        return;
      }

      const errorList: any = {};
      const keys = Object.keys(errors);
      keys.forEach((key) => {
        const items = (errors as Record<string, any>)[key];
        if (items && typeof items === 'object' && items.type && items.message) {
          errorList[key] = items;
        } else if (items && typeof items === 'object') {
          Object.keys(items)?.forEach((k: any) => {
            errorList[`${key}.${k}`] = items[k];
          });
        }
      });
      scrollToError(errorList);
      if (!force) {
        hasScrolledToErrorRef.current = true;
      }
    } else {
      hasScrolledToErrorRef.current = false;
    }
  };

  const preventSubmitIfError = (
    hasError: boolean,
    errors?: FieldErrors,
    errorKey?: string,
  ) => {
    if (hasError) {
      if (errorKey) {
        const errorList = { [errorKey]: { type: 'manual', message: '' } };
        scrollToError(errorList);
      } else if (errors) {
        processFormErrors(errors, true);
      }
      return true;
    }
    return false;
  };

  return {
    elRef,
    scrollToError,
    resetScrollRef,
    preventSubmitIfError,
    processFormErrors,
    hasScrolledToErrorRef,
  };
};
